import React from 'react';
import { Typography } from 'ha/ui/next/Typography';
import {
  SuitableForFilterValue,
  SuitableForValue,
} from 'ha/types/SearchFilters';
import { withIntl, IntlProps } from 'ha/i18n';
import FilterCheckbox from './FilterCheckbox';
import Grid from 'ha/ui/next/Grid';

interface Props {
  suitableFor: SuitableForFilterValue;
  onToggle: (selection: SuitableForValue, selected: boolean) => void;
}

export const SuitableForFilter: React.FC<Props & IntlProps> = ({
  suitableFor,
  onToggle,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography.ParagraphTitle data-test-locator="SuitableForFilter Title">
      {T('Suitable for')}
    </Typography.ParagraphTitle>

    <Grid container>
      <Grid item md={6}>
        <FilterCheckbox
          name={SuitableForValue.STUDENTS}
          onToggle={(selected: boolean) =>
            onToggle(SuitableForValue.STUDENTS, selected)
          }
          isActive={suitableFor.includes(SuitableForValue.STUDENTS)}
          data-test-locator="SuitableForFilter Students"
        >
          <Typography.Paragraph noWrap>{T('Students')}</Typography.Paragraph>
        </FilterCheckbox>
      </Grid>
      <Grid item md={6}>
        <FilterCheckbox
          name={SuitableForValue.WORKING_PROFESSIONALS}
          onToggle={(selected: boolean) =>
            onToggle(SuitableForValue.WORKING_PROFESSIONALS, selected)
          }
          isActive={suitableFor.includes(
            SuitableForValue.WORKING_PROFESSIONALS,
          )}
          data-test-locator="SuitableForFilter WorkingProfessionals"
        >
          <Typography.Paragraph noWrap>
            {T('Working professionals')}
          </Typography.Paragraph>
        </FilterCheckbox>
      </Grid>
      <Grid item md={6}>
        <FilterCheckbox
          name={SuitableForValue.COUPLES}
          onToggle={(selected: boolean) =>
            onToggle(SuitableForValue.COUPLES, selected)
          }
          isActive={suitableFor.includes(SuitableForValue.COUPLES)}
          data-test-locator="SuitableForFilter Couples"
        >
          <Typography.Paragraph noWrap>{T('Couples')}</Typography.Paragraph>
        </FilterCheckbox>
      </Grid>
    </Grid>
  </React.Fragment>
);

export default withIntl(SuitableForFilter);
